import HomePage from '@/components/HomePage';
import MyCollection from '@/components/MyCollection';
import { useUser } from '@/db/auth';

export default function Index() {
  const { data: user } = useUser();

  return user ? <MyCollection /> : <HomePage />;
}
